<div class="wrapper">
  <div class="container">
    <img src="/assets/images/logo.png" alt="logo rebuilt" />
    <h4>This site is under maintenance</h4>
    <p>We're preparing to serve you better.</p>
  </div>
</div>
